/**
 * Payment methods actions types
 */

export const PAYMENT_METHODS_REQUESTED = '[PAYMENT_METHOD][LIST] REQUESTED';
export const PAYMENT_METHODS_SUCCEEDED = '[PAYMENT_METHOD][LIST] SUCCEEDED';
export const PAYMENT_METHODS_FAILED = '[PAYMENT_METHOD][LIST] FAILED';
export const PAYMENTS_METHOD_SELECT_LABEL = '[PAYMENTS_METHOD][SELECT] LABEL';
